import {
  Input,
  Inject,
  OnInit,
  Output,
  Component,
  EventEmitter,
} from 'ng-metadata/core';

import usaStateHtml from './usa-state.html';
import { PopulateService } from 'services/populate.service';
import * as $ from 'jquery';

/**
 * Form control for USA state field
 */
@Component({
  selector: 'gw-form-usa-state',
  template: usaStateHtml,
})
export class FormUsaStateComponent implements OnInit {
  public GW = (<any>window).GW;
  public selectedState: any;
  public usaStateSearch: string;
  public usaStates: any = this.GW.stateJurisdictions;

  @Input() label;
  @Input() usaState;
  @Input() disabled;
  @Output() onChange = new EventEmitter;

  constructor(
    @Inject('$filter') private $filter,
    @Inject('orderByFilter') private orderBy: ng.IFilterOrderBy,
    @Inject(PopulateService) private populateService: PopulateService,
  ) { }

  async ngOnInit() {
    this.label = this.label || 'State';
    this.initAutocompleteValue(this.usaState);
  }

  clearSearchTerm() {
    this.usaStateSearch = '';
  }

  initAutocompleteValue(iso: string) {
    this.selectedState = this.usaStates[iso];
  }

  /**
   * When a md-select-backdrop exist the page can't be scrolled
   * but the default angular scroll blocker is not working
   *
   * @param show
   */
  onShow(show: boolean) {
    $('html, body')
      .css('overflow', show ? 'hidden' : 'auto');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/usa-state/usa-state.component.ts